import { render, staticRenderFns } from "./JobPostIndex.vue?vue&type=template&id=766b48e5&scoped=true&"
import script from "../../../services/company/job_post/job-post-index.js?vue&type=script&lang=js&"
export * from "../../../services/company/job_post/job-post-index.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_category.css?vue&type=style&index=0&id=766b48e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b48e5",
  null
  
)

export default component.exports